import "./Faq06.css";

import React, { useState } from "react";

import { useScrollReveal } from "../../../../hooks/useScrollReveal";

function Faq06() {
  const [activeIndex, setActiveIndex] = useState(0);
  const { ref, isVisible } = useScrollReveal();

  const faqs = [
    {
      question: "What exactly does Served do?",
      answer:
        "Served is an automated DMCA takedown and leak protection agency built for content creators and models. We use advanced AI to continuously scan the web for your stolen content, unauthorized re-uploads, and fake profiles. Once a threat is detected, our system automatically issues legally binding takedown notices to get the content removed instantly, protecting your hard-earned revenue.",
    },
    {
      question: "How fast does your scanning and removal process work?",
      answer:
        "Our AI is strategically relentless. It scans over 10,000 sites per hour, 24/7. Once a leak is detected, our system automatically initiates the DMCA process. While removal times depend on the hosting platform, the vast majority of stolen content is scrubbed from the web within 24 to 48 hours of detection.",
    },
    {
      question: "What platforms do you actively monitor?",
      answer:
        "We cast a massive net. Our systems monitor the deepest corners of the web, including major social platforms (Reddit, Twitter/X, Telegram), massive tube sites, file-sharing hosts, and private forums where leaks are commonly traded.",
    },
    {
      question:
        "Will I have to fill out any legal paperwork or send emails myself?",
      answer:
        "No. Our team manages the entire enforcement process on your behalf. Detection, documentation,and takedown notices are handled internally so you can stay focused on creating while we handle the protection work.",
    },
    {
      question: "How do leaks actually impact my bottom line?",
      answer:
        "A single leak is a direct hit to your bank account. If a stolen video gets 1,000 views on a free forum, that is potentially 1,000 lost subscribers. At a $15/month subscription rate, that’s $15,000 in lost potential revenue. We plug the leak so you can reclaim that income.",
    },
    {
      question: "Can you remove fake profiles or impersonators?",
      answer:
        "Yes. Impersonators don't just steal your content; they steal your reputation and scam your fans. Our system flags and destroys fake social media accounts, fraudulent link-in-bio pages, and unauthorized fan pages trying to profit off your likeness.",
    },
    {
      question:
        "Do you only clean up old leaks, or do you protect new content too?",
      answer:
        "Both. When you join Served, we do a massive initial sweep to clean up your historical digital footprint and destroy old links. From there, our system shifts into active monitoring, instantly flagging and removing any new leaks the moment they hit the web.",
    },
    {
      question: "What happens if a website ignores the DMCA takedown request?",
      answer:
        "We don't back down. If a site owner ignores a legal takedown, we bypass them entirely. We escalate the strike directly to their server hosting providers, domain registrars, and search engines (like Google) to have the page de-indexed and the content forcefully removed.",
    },
    {
      question: "Is my personal information kept secure?",
      answer:
        "Your privacy is our absolute highest priority. We operate entirely as an authorized third-party agent on your behalf. This means your real name, address, and personal details stay completely out of the public DMCA notices. We act as your digital shield.",
    },
  ];

  const toggleAnswer = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };
  return (
    <div
      ref={ref}
      className={`Faq06 section section-reveal ${isVisible ? "section--visible" : ""}`}
      id="Faq06"
    >
      <div className="container">
        <div className="Faq06-box">
          {faqs.map((faq, index) => (
            <div key={index} onClick={() => toggleAnswer(index)}>
              <h4>{faq.question}</h4>
              {activeIndex === index && <p className="answer">{faq.answer}</p>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Faq06;
